import { z } from 'zod';

const simulationTaskFormSchema = z.object({
  amount: z.coerce.number().min(1),
  priority: z.boolean(),
  delete: z.boolean(),
  technology: z.string().optional(),
});

export const simulationFormSchema = z.record(z.coerce.number(), simulationTaskFormSchema);
export type SimulationFormData = z.infer<typeof simulationFormSchema>;
